export const CONTACT_EMAIL = "contact@Gazmatek.com";

export const CONTACT_PHONE = "+32 2 000 00 00";

export const CONTACT_ADDRESS = {
  street: "Rue de la Musique 1",
  postalCode: "1000",
  city: "Bruxelles",
  country: "Belgique",
} as const;

export const SOCIAL_LINKS = {
  facebook: "https://facebook.com/Gazmatek",
  instagram: "https://instagram.com/Gazmatek",
  linkedin: "https://linkedin.com/company/Gazmatek",
  github: "#",
} as const;
